module.exports = __webpack_public_path__ + "static/media/mu.67c8f362.svg";